// V3 BRAND MODULES
import TestBrandModule from 'src/components/common/modules/v3/brand/v3-test-brand-module';
import V3BreakerQuote from 'src/components/common/modules/v3/brand/v3-breaker-quote';
import V3BreakerBio from 'src/components/common/modules/v3/brand/v3-breaker-bio';
import V3InlineImageModule from 'src/components/common/modules/v3/brand/v3-inline-image-module';
import V3MagazineNameplate from 'src/components/common/modules/v3/brand/v3-magazine-nameplate';
import V3BrandArtcileHeroModule from 'src/components/common/modules/v3/brand/v3-brand-artcile-hero-module';
import V3BreakerVideoModule from 'src/components/common/modules/v3/brand/v3-breaker-video-module';
import V3RichText from 'src/components/common/modules/v3/brand/v3-rich-text';
import V3BreakerImages from 'src/components/common/modules/v3/brand/v3-breaker-images';
import V3AreaTabbedListModule from 'components/common/modules/v3/brand/v3-area-tabbed-list-module';
import V3BreakerImageBatch2 from 'src/components/common/modules/v3/brand/v3-breaker-image-batch2';
import V3BreakerAppDownload from 'src/components/common/modules/v3/brand/v3-breaker-app-download';
import V3BrandImageHeroModule from 'src/components/common/modules/v3/brand//v3-brand-image-hero-module';
import V3BrandVideoHeroModule from 'src/components/common/modules/v3/brand/v3-brand-video-hero-module';
import V3BreakerBookingWidget from 'src/components/common/modules/v3/brand/v3-breaker-booking-widget';
import V3DiscoverMoreModule from 'src/components/common/modules/v3/brand/v3-discover-more-module';
import V3ThreeUpCardsModule from 'src/components/common/modules/v3/brand/v3-three-cards-module';
import V3FilterModule from 'src/components/common/modules/v3/brand/v3-filter-module';
import V3FourUpCardCarouselModule from 'components/common/modules/v3/brand/v3-four-up-card-carousel-module';
import V3FeatureOneUpWTwoImages from 'src/components/common/modules/v3/brand/v3-feature-one-up-w-two-images';
import V3CoverPackageModule from 'src/components/common/modules/v3/brand/v3-cover-package-module';
import V3SubBrandBanner from 'src/components/common/modules/v3/brand/v3-sub-brand-banner';
import V3EditorialFeature1Up from 'src/components/common/modules/v3/brand/v3-editorial-feature1-up';
import V3Basic1UpModule from 'src/components/common/modules/v3/brand/v3-basic1-up-module';
import V3Lists from 'src/components/common/modules/v3/brand/v3-lists';
import V3BrandLiveEventHeroModule from 'src/components/common/modules/v3/brand/v3-brand-live-event-hero-module';

import V3BreakerPromo from 'src/components/common/modules/v3/brand/v3-breaker-promo';
import V3SponsoredContentHeroModule from 'src/components/common/modules/v3/brand/v3-sponsored-content-hero-module';
import V3CategoryLandingHeroModule from 'src/components/common/modules/v3/brand/v3-category-landing-hero-module';
import V3FixturePlannerModule from 'src/components/common/modules/v3/brand/v3-fixture-planner-module';
import V3AdUnits from 'src/components/common/modules/v3/brand/v3-ad-units';
import V3ShoppableOneUpCardCarousel from 'src/components/common/modules/v3/brand/v3-shoppable-one-up-card-carousel';
import V3InlineCard from 'src/components/common/modules/v3/brand/v3-inline-card';

import v3InlineAccordion from 'src/components/common/modules/v3/brand/v3-inline-accordion';

//constants
import { MODULE_TYPES } from 'src/components/common/modules/v3/brand/v3-module-spacings/constant';
import V3HighlightThreeUp from 'src/components/common/modules/v3/brand/v3-highlight-three-up';
import V3BreakerCompetitionModule from 'src/components/common/modules/v3/brand/v3-breaker-competition-module';
import V3BrandHotelDealsModule from 'src/components/common/modules/v3/brand/v3-brand-hotel-deals-module';
import V3FourUpCardsModule from 'src/components/common/modules/v3/brand/v3-four-up-cards-module';
import V3HighlightFiveUp from 'components/common/modules/v3/brand/v3-highlight-five-up';
import V3InlineVideo from 'src/components/common/modules/v3/brand/v3-inline-video';
import V3AuthorHero from 'src/components/common/modules/v3/brand/v3-author-hero';
import V3SixUpCardGrid from 'components/common/modules/v3/brand/v3-six-up-card-grid';
import V3HorizontallyTabbedListModule from 'src/components/common/modules/v3/brand/v3-horizontally-tabbed-list-module';
import V3EditorialOneUpCarouselModule from 'src/components/common/modules/v3/brand/v3-editorial-one-up-carousel-module';
import V3DynamicSubNavModule from 'src/components/common/modules/v3/brand/v3-dynamic-sub-nav-module';
import V3RecommendationModule from 'src/components/common/modules/v3/brand/v3-recommendation-module';

import V3TestimonialCarousel from 'src/components/common/modules/v3/brand/v3-testimonial-carousel';
import v3HeadlineBreakerModule from 'src/components/common/modules/v3/brand/v3-headline-breaker-module';
import v3SeoFooter from 'src/components/common/modules/v3/brand/v3-seo-footer';

type ModulesTypeList = {
  [key: string]: {
    module: () => any;
    type: (typeof MODULE_TYPES)[keyof typeof MODULE_TYPES];
  };
};

type BrandModules = {
  [key: string]: () => any;
};

type BrandModulesTypes = {
  [key: string]: (typeof MODULE_TYPES)[keyof typeof MODULE_TYPES];
};

const BrandModulesList: ModulesTypeList = {
  //story telling
  v3breakerQuote: { module: () => V3BreakerQuote, type: MODULE_TYPES.story_telling },
  v3breakerBio: { module: () => V3BreakerBio, type: MODULE_TYPES.story_telling },
  v3inlineImage: { module: () => V3InlineImageModule, type: MODULE_TYPES.story_telling },
  v3breakerVideo: { module: () => V3BreakerVideoModule, type: MODULE_TYPES.story_telling },
  v3richTextEditor: { module: () => V3RichText, type: MODULE_TYPES.story_telling },
  v3threeUpCards: { module: () => V3ThreeUpCardsModule, type: MODULE_TYPES.non_story_telling },
  v3breakerImages: { module: () => V3BreakerImages, type: MODULE_TYPES.story_telling }, // Breaker-collage, Breaker-gallery, Breaker-rich-carousel modules switch through here according to the moduleStyle
  v3breakerImageBatch2: { module: () => V3BreakerImageBatch2, type: MODULE_TYPES.story_telling },
  v3breakerImage: { module: () => V3BreakerImageBatch2, type: MODULE_TYPES.story_telling },
  v3lists: { module: () => V3Lists, type: MODULE_TYPES.story_telling },
  v3breakerPromo: { module: () => V3BreakerPromo, type: MODULE_TYPES.story_telling },
  v3inlineAccordion: { module: () => v3InlineAccordion, type: MODULE_TYPES.story_telling },
  v3inlineCard: { module: () => V3InlineCard, type: MODULE_TYPES.story_telling },
  v3inlineVideo: { module: () => V3InlineVideo, type: MODULE_TYPES.story_telling },
  v3numberdList: { module: () => V3Lists, type: MODULE_TYPES.story_telling },
  v3styledNumberedList: { module: () => V3Lists, type: MODULE_TYPES.story_telling },
  v3styledHorizontalList: { module: () => V3Lists, type: MODULE_TYPES.story_telling },

  //non story telling
  v3TestBrandModule: { module: () => TestBrandModule, type: MODULE_TYPES.non_story_telling },
  v3areaTabbedList: { module: () => V3AreaTabbedListModule, type: MODULE_TYPES.non_story_telling },
  v3bookingWidget: { module: () => V3BreakerBookingWidget, type: MODULE_TYPES.non_story_telling },
  v3discoverMorePromo: { module: () => V3DiscoverMoreModule, type: MODULE_TYPES.non_story_telling },
  v3feature1UpW2Images: { module: () => V3FeatureOneUpWTwoImages, type: MODULE_TYPES.non_story_telling },
  v3fourUpCarousel: { module: () => V3FourUpCardCarouselModule, type: MODULE_TYPES.non_story_telling },
  v3highlight5Up: { module: () => V3HighlightFiveUp, type: MODULE_TYPES.non_story_telling },
  v3shoppable1UpCarousel: { module: () => V3ShoppableOneUpCardCarousel, type: MODULE_TYPES.non_story_telling },
  v3testimonialCarousel: { module: () => V3TestimonialCarousel, type: MODULE_TYPES.non_story_telling },
  v3appDownload: { module: () => V3BreakerAppDownload, type: MODULE_TYPES.non_story_telling },
  v3subBrandBanner: { module: () => V3SubBrandBanner, type: MODULE_TYPES.non_story_telling },
  v3editorialFeature1Up: { module: () => V3EditorialFeature1Up, type: MODULE_TYPES.non_story_telling },
  v3basic1Up: { module: () => V3Basic1UpModule, type: MODULE_TYPES.non_story_telling },
  v3highlight3Up: { module: () => V3HighlightThreeUp, type: MODULE_TYPES.non_story_telling },
  v3filterModule: { module: () => V3FilterModule, type: MODULE_TYPES.non_story_telling },
  v3fixturePlanner: { module: () => V3FixturePlannerModule, type: MODULE_TYPES.non_story_telling },
  v3sixUpCarousel: { module: () => V3SixUpCardGrid, type: MODULE_TYPES.non_story_telling },
  v3horizontalTabbedList: { module: () => V3HorizontallyTabbedListModule, type: MODULE_TYPES.non_story_telling },
  v3editorialOneUpCarousel: { module: () => V3EditorialOneUpCarouselModule, type: MODULE_TYPES.non_story_telling },

  //heros
  v3magazineNameplate: { module: () => V3MagazineNameplate, type: MODULE_TYPES.hero },
  v3articleHero: { module: () => V3BrandArtcileHeroModule, type: MODULE_TYPES.hero },
  v3imageHero: { module: () => V3BrandImageHeroModule, type: MODULE_TYPES.hero },
  v3heroVideo: { module: () => V3BrandVideoHeroModule, type: MODULE_TYPES.hero },
  v3liveEventHero: { module: () => V3BrandLiveEventHeroModule, type: MODULE_TYPES.hero },
  v3videoHero: { module: () => V3BrandVideoHeroModule, type: MODULE_TYPES.hero },
  v3coverPackage: { module: () => V3CoverPackageModule, type: MODULE_TYPES.hero },
  v3authorHero: { module: () => V3AuthorHero, type: MODULE_TYPES.hero },
  v3sponsoredContentHero: { module: () => V3SponsoredContentHeroModule, type: MODULE_TYPES.hero },
  v3adUnit: { module: () => V3AdUnits, type: MODULE_TYPES.no_space },
  v3categoryLandingHero: { module: () => V3CategoryLandingHeroModule, type: MODULE_TYPES.hero },
  v3AdUnits: { module: () => V3AdUnits, type: MODULE_TYPES.no_space },
  v3HotelDeals: { module: () => V3BrandHotelDealsModule, type: MODULE_TYPES.no_space },
  v3breakerCompetition: { module: () => V3BreakerCompetitionModule, type: MODULE_TYPES.non_story_telling },
  v3fourUpCards: { module: () => V3FourUpCardsModule, type: MODULE_TYPES.non_story_telling },
  v3headlineBreaker: { module: () => v3HeadlineBreakerModule, type: MODULE_TYPES.no_space },

  // go guides modules
  v3seoFooter: { module: () => v3SeoFooter, type: MODULE_TYPES.no_space },
  v3dynamicSubNav: { module: () => V3DynamicSubNavModule, type: MODULE_TYPES.no_space },
  v3recommendationModule: { module: () => V3RecommendationModule, type: MODULE_TYPES.no_space },
};

const v3BrandModules: BrandModules = Object.keys(BrandModulesList).reduce(
  (a, c) => ({
    ...a,
    [c]: BrandModulesList[c].module,
  }),
  {},
);

const v3BrandModulesTypes: BrandModulesTypes = Object.keys(BrandModulesList).reduce(
  (a, c) => ({
    ...a,
    [c]: BrandModulesList[c].type,
  }),
  {},
);

export default v3BrandModules;
export { v3BrandModulesTypes };
